import { CapabilityDTO, SearchResultDTOTypeEnum } from '@atlassiansox/phobos-client-ts';
import React, { FC, useState } from 'react';
import Badge from '@atlaskit/badge';

import {
  BreachCount,
  CapabilityTier,
  ProductEntityLink,
  TeamEntityLink,
  entityLinkDefaultClassName,
} from '@/components/primitive';
import { tableExpandContentStyles } from '@/styles';
import { useLocationController } from '@/controllers';

import * as stylesSearch from '../../search-layouts/styles';
import * as stylesResults from '../styles';
import SearchListType from '../search-list-titles/search-list-type';
import SearchListName from '../search-list-titles/search-list-name';

import SearchListCapabilityCard from './search-list-capability-card';

type SearchListBasicCapabilityItemProps = {
  capability: CapabilityDTO;
};

const SearchListDashboardCapabilityItem: FC<SearchListBasicCapabilityItemProps> = ({
  capability,
}) => {
  const { isProductPage, isTeamPage } = useLocationController();

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
    if ((e.target as HTMLElement).classList.contains(entityLinkDefaultClassName)) return;
    setIsOpen(!isOpen);
  };

  const { breaches, sloCount, qualityIssues, importance, product, team } = capability;

  return (
    <li>
      <div css={[stylesSearch.capabilityResultRowStyles]} onClick={handleToggle}>
        <SearchListType
          hideType
          isCardExpanded={isOpen}
          type={SearchResultDTOTypeEnum.Capability}
        />
        <SearchListName item={capability} type={SearchResultDTOTypeEnum.Capability} />
        <div>
          {isTeamPage && (
            <ProductEntityLink
              name={product.name}
              publicId={product.publicId}
              locationSearch="?showDrafts=true"
              hideTooltip
            />
          )}
          {isProductPage && (
            <TeamEntityLink
              name={team.name}
              publicId={team.publicId}
              locationSearch="?showDrafts=true"
              hideTooltip
            />
          )}
        </div>
        <div>
          <CapabilityTier tier={importance} />
        </div>
        <BreachCount count={breaches} />
        <BreachCount isWarning count={qualityIssues} />
        <div>
          <Badge max={Infinity} appearance="default">
            {sloCount}
          </Badge>
        </div>
      </div>
      {isOpen && (
        <div css={[stylesResults.cardContentStyles, tableExpandContentStyles]}>
          <SearchListCapabilityCard id={capability.publicId} />
        </div>
      )}
    </li>
  );
};

export default SearchListDashboardCapabilityItem;
